<template>
  <v-dialog v-model="newUserDialog" max-width="1200px" persistent scrollable>
    <v-card style="border-radius: 10px">
      <v-toolbar
        dark
        style="background-color: #fddf00; color: black"
        class="elevation-0"
      >
        <v-toolbar-title><h4>Create Commission Withdraw</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false)" color="black" size="30"
          >close</v-icon
        >
      </v-toolbar>
      <v-card-text style="height: auto;" class="px-4 pt-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-toolbar-title><h4>Manager Commission</h4> </v-toolbar-title>
          <v-container>
            <v-layout row wrap align-center>
              <v-autocomplete
                :rules="[(v) => !!v || 'Required']"
                outline
                :items="province_list"
                outlined
                :loading="loadingProvince"
                item-text="province_name_th"
                item-value="province_id"
                dense
                label="Province"
                class="mr-2"
                v-model="province"
                @change="
                  districtList = [];
                  getDistrictList();
                "
              >
                ></v-autocomplete
              >
              <v-autocomplete
                v-if="selectdistrict"
                :rules="[(v) => !!v || 'Required']"
                outline
                :items="DistrcitCommissionByid"
                outlined
                :loading="loadingProvince"
                item-text="district_name_th"
                item-value="district_id"
                dense
                v-model="district"
                label="District"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                disabled
                :rules="[(v) => !!v || 'Required']"
                outline
                :items="DistrcitCommissionByid"
                outlined
                :loading="loadingProvince"
                item-text="district_name_th"
                item-value="district_id"
                dense
                v-model="district"
                label="District"
              ></v-autocomplete>
            </v-layout>
          </v-container>
          <v-container>
            <v-layout row wrap>
              <v-layout xs12 sm3>
                <v-toolbar-title style="margin-top:15px"
                  ><h4>Commission type :</h4>
                </v-toolbar-title>
              </v-layout>
              <v-layout xs12 sm9>
                <v-radio-group v-model="radioGroup" row v-if="lockButton">
                  <v-radio label="Credit" value="1" color="yellow"></v-radio>
                  <v-radio label="Percent" value="2" color="yellow"></v-radio>
                </v-radio-group>
                <v-radio-group v-model="radioGroup" row v-else>
                  <v-radio
                    disabled
                    label="Credit"
                    value="2"
                    color="yellow"
                  ></v-radio>
                  <v-radio
                    disabled
                    label="Percent"
                    value="2"
                    color="yellow"
                  ></v-radio>
                </v-radio-group>
              </v-layout>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
            </v-layout>

            <div v-if="radioGroup == '1'">
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>Commission unit :</h4>
                  </v-toolbar-title>
                </v-flex>
                <v-flex xs12 sm6 style="padding:20px">
                  <v-text-field
                    type="number"
                    :rules="[rules.required, rules.number, rules.counterMore]"
                    v-model="formCredit.number"
                    placeholder="Enter number"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>Credit</h4>
                  </v-toolbar-title>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>Maximum Commission :</h4>
                  </v-toolbar-title>
                </v-flex>
                <v-flex xs12 sm6 style="padding:20px">
                  <v-text-field
                    disabled
                    placeholder="Enter number"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-toolbar-title
                    ><h4 style="color:gray; margin-top: 35px;">Credit</h4>
                  </v-toolbar-title>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="radioGroup == '2'">
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>Commission unit :</h4>
                  </v-toolbar-title>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-container>
                    <v-text-field
                      type="number"
                      :rules="[rules.required, rules.counter, rules.number]"
                      v-model="formCredit.number"
                      placeholder="Enter number"
                      outline
                    ></v-text-field>
                  </v-container>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>%</h4>
                  </v-toolbar-title>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>Maximum Commission :</h4>
                  </v-toolbar-title>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-container>
                    <v-text-field
                      :rules="[rules.required, rules.number, rules.counterMore]"
                      type="number"
                      v-model="maxCredit"
                      placeholder="Enter number"
                      outline
                    ></v-text-field>
                    <small style="color:red">{{ errMsg }}</small>
                  </v-container>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>Credit</h4>
                  </v-toolbar-title>
                </v-flex>
              </v-layout>
            </div>
          </v-container>
          <v-card-actions style="padding-bottom: 30px" class="pr-4">
            <v-spacer></v-spacer>
            <v-btn
              @click="withdraw"
              :loading="isAdding"
              dark
              color="black"
              style="
                width: 120px;
                background: #000000 0% 0% no-repeat padding-box;
                box-shadow: 0px 3px 6px #00000029;
                border-radius: 7px;
                font-weight: bold;
                letter-spacing: 0.1rem;
              "
              >CONFIRM</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import _ from "lodash";

let _this = this;
export default {
  props: ["newUserDialog"],
  data() {
    return {
      valid: true,
      loadingProvince: false,
      districtList: [],
      isLoadingDistrict: false,
      isAdding: false,
      maximum: "Enter number",
      selectdistrict: false,
      province: "",
      district: "",
      lockButton: true,
      formCredit: {
        number: "",
      },
      maxCredit: 0,
      radioGroup: "",
      rules: {
        counter: (value) => (value >= 1 && value <= 100) || "Min 1 or Max100",
        required: (value) => !!value || "Required.",
        number: (value) => {
          const pattern = /^[-+]?[0-9]+\.[0-9]+$/;
          return !pattern.test(value) || "Not Decimal";
        },
        counterMore: (value) => value >= 1 || "Min 1",
      },
      lock: true,
      errMsg: "",
    };
  },
  watch: {
    async newUserDialog() {
      if (this.newUserDialog == true) {
        this.clear();
      }
    },
    async radioGroup() {
      if (this.radioGroup == "2") {
        this.maxCredit = null;
        this.formCredit = {
          number: "",
        };
      } else if (this.radioGroup == "1") {
        this.maxCredit = 0;
        this.formCredit = {
          number: "",
        };
      }
    },
  },
  computed: {
    ...mapState({
      DistrcitCommissionByid: (state) => state.fetchWithdraw.district,
    }),
    ...mapGetters({
      province_list: "fetchProvinceBack/provinceSplited",
    }),
  },
  methods: {
    ...mapActions({
      fetchDistrcitCommissionByid:
        "fetchWithdraw/fetchDistrcitCommissionWithdraw",
    }),

    async withdraw() {
      if (this.$refs.form.validate()) {
        let commissionWithdraw = {
          commission_withdraw_type: this.radioGroup,
          commission_withdraw_province_id: this.province,
          commission_withdraw_district_id: this.district,
          commission_withdraw_amount: this.formCredit.number,
          commission_withdraw_commission_maximun: this.maxCredit,
        };
        this.isAdding = true;
        let _this = this;
        this.$emit("onSaved", {
          form: commissionWithdraw,
          done() {
            _this.isAdding = false;
          },
        });
      }
    },

    async getDistrictList() {
      this.selectdistrict = true;
      this.loadingDistrict = true;
      await this.fetchDistrcitCommissionByid({
        manager_id: this.province,
      });
      this.loadingDistrict = false;
      this.isLoadingDistrict = false;
    },
    clear() {
      (this.formCredit = {
        number: "",
      }),
        (this.formPercent = {
          unit: "",
          max: "",
        }),
        (this.province = ""),
        (this.district = ""),
        (this.selectdistrict = false),
        (this.errMsg = "");
      this.$refs.form.resetValidation();
      this.radioGroup = "1";
      this.lockButton = true;
    },
  },
};
</script>

<style>
.line-newpass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-newpass:after {
  content: "Set Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>
